const MIN_PAYMENT_AMOUNT = 3000;

export function getCreditsToRedeem(input: {
  baseTotal: number;
  requestedCredits: number;
  creditsBalance: number;
}): number {
  if (input.baseTotal < MIN_PAYMENT_AMOUNT) {
    return 0;
  }

  const maxRequested = Math.min(input.requestedCredits, input.creditsBalance, input.baseTotal);
  const remaining = input.baseTotal - maxRequested;

  if (remaining < MIN_PAYMENT_AMOUNT) {
    return Math.max(input.baseTotal - MIN_PAYMENT_AMOUNT, 0);
  }

  return maxRequested;
}

export function calculatePaymentTotals(input: {
  invoiceTotal: number;
  subscriptionTotal: number;
  creditsBalance: number;
  useCredits: boolean;
  cardFeePercentage: number;
  isCard: boolean;
}) {
  const baseTotal = input.invoiceTotal + input.subscriptionTotal;
  const requestedCredits = input.useCredits ? input.creditsBalance : 0;
  const creditsApplied = getCreditsToRedeem({
    baseTotal,
    requestedCredits,
    creditsBalance: input.creditsBalance,
  });
  const amountBeforeCardFee = baseTotal - creditsApplied;
  const cardFee = input.isCard ? Math.round(amountBeforeCardFee * (input.cardFeePercentage / 100)) : 0;
  const finalTotal = amountBeforeCardFee + cardFee;

  return {
    baseTotal,
    creditsApplied,
    amountBeforeCardFee,
    cardFee,
    finalTotal,
  };
}
